import $ from 'jquery';
import Cookies from 'js-cookie';

export default () => {
  $(document).on('menusWillClose', () => {
    if (!$('[data-region-redirect-modal]').hasClass('Modal--open')) {
      return;
    }

    Cookies.set('region_ignore', 'true', { expires: 365, path: '/' });
  });
};